module.exports = __webpack_public_path__ + "img/bb_g1_t_nose-06.cc5c0a33.svg";